import type { ReactNode } from 'react'

type ListingSectionProps = {
  title: string
  titleId: string
  children: ReactNode
  className?: string
}

export const ListingSection = ({
  title,
  titleId,
  children,
  className = 'blog-section',
}: ListingSectionProps) => (
  <section className={className} aria-labelledby={titleId}>
    <h2 id={titleId}>{title}</h2>
    {children}
  </section>
)
